import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.agentAndAdmin,
	routes: [
		{
			path: '/archived-contracts',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/archived-contracts/:id',
			exact: true,
			component: Page.ContractDetailsDailog
		},
	]
};